<template>
  <div id="app"><router-view /></div>
</template>

<script>

export default {
  name: 'App'
};
</script>

<style lang="less" scoped>
#app {
/*  @import url('assets/css/main.css');*/
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  padding-bottom:constant(safe-area-inset-bottom);
  padding-bottom:env(safe-area-inset-bottom);
}
</style>



// WEBPACK FOOTER //
// src/App.vue